/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

import { createApp } from "vue";
import { createStore } from 'vuex';
import App from "./App.vue";
// import Toast from 'vue-toastification';
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { ResizeColumnsModule } from 'tabulator-tables';
import { Module } from 'tabulator-tables';
import Chart from 'chart.js/auto';
import { DateTime } from "luxon";
// import store from "./store";

window.Tabulator = Tabulator;
window.Chart = Chart;

//? tabulator additions
class CustomModule extends Module {
  static moduleName = "custom";
  static moduleInitOrder = 10;

  constructor(table) {
    super(table);
    //register table options
    this.registerTableOption("tableID", false);
    this.registerTableOption("dataType", 'keyword');
    this.registerTableOption("subTables", []);

    //register column options
    this.registerColumnOption("easyCol", false);
    this.registerColumnOption("purchaseCol", false);
    this.registerColumnOption("dontHide", false);
    this.registerColumnOption("muta", false);
    this.registerColumnOption("mutaParams", false);
    this.registerColumnOption("mutaNumber", false);
    this.registerColumnOption("type", false);
    this.registerColumnOption("useful");
    //register table functions
    //register component functions
  }

  initialize() {
    //subscribe to internal events
    //register data handlers
  }
}

Tabulator.extendModule("persistence", "writers", {
  saveToVariables: function (id, type, data) {
    //id - tables persistence id
    //type - type of data being persisted ("sort", "filter", "group", "page" or "columns")
    //data - array or object of data

    store.commit("storeTable", { id, data })
  },
});

Tabulator.extendModule("persistence", "readers", {
  saveToVariables: function (id, type) {
    //id - tables persistence id
    //type - type of data being persisted ("sort", "filter", "group", "page" or "columns")

    var data = localStorage.getItem(id + "-" + type);

    return data ? JSON.parse(data) : false;
  },
});

Tabulator.registerModule(CustomModule);

Tabulator.extendModule("mutator", "mutators", {
  'CarGoFast': function (value, data, type, params) {
    return "yellwo";
  },
  'customColumnMutator': function (value, data, type, params) {
    var whatis = parserer(params, data);
    if (whatis == "NaN") return "Missing Data";
    return whatis;
  },
  'customBucketMutator': function (value, data, type, params) {
    var whatis = parsererbucket(params, data);
    if (whatis == "NaN") return "Missing Data";
    return whatis;
  },
  'customListMutator': function (value, data, type, params) {
    //params.type, params.field, params.dataField, params.subArray;aggScore
    //value should end up being array of rows.
    //param will have 3 things, the type of math and the field to apply it to. the 3rd thing that is the field of the list data.
    if (params.dataField == undefined) return "No data";
    if (data[params.dataField] != undefined) return statisticsCalc[params.type].call({ field: params.field, data: data[params.dataField] });
    //if (this.data[this.params.dataField] != undefined) return StatisticsCalc(this.params, this.data[this.params.dataField]);
    return "No data";
  },
  'customAggMutator': function (value, data, type, params) {
    //params.type, params.field, params.dataField, params.subArray;aggScore
    //value should end up being array of rows.
    //param will have 3 things, the type of math and the field to apply it to. the 3rd thing that is the field of the list data.
    if (params.dataField == undefined) return "No data";
    if (data[params.dataField] != undefined && params.superField != undefined) return statisticsCalc[params.type].call({ field: params.field, data: data[params.dataField][params.superField] });
    if (data[params.dataField] != undefined) return statisticsCalc[params.type].call({ field: params.field, data: data[params.dataField] });
    //if (this.data[this.params.dataField] != undefined) return StatisticsCalc(this.params, this.data[this.params.dataField]);
    return "No data";
  },
});

Tabulator.extendModule("format", "formatters", {
  pivotGroupFormat: function (cell) {
    cell.getElement().style.color = "white"
    cell.getElement().style.backgroundColor = "grey";
    // var prevrow = cell.getRow().getPrevRow();
    // if (prevrow != false &&  && prevrow.getData()[cell.getField()] == cell.getValue()) return "repeat";
    return cell.getValue();
  },
  goTo: function (cell, formatterParams) {
    return "Open Serp";
  },
  EasyCol: function (cell, formatterParams) {
    return cell.getValue();
  },
  ConditionalFormatting: function (cell, formatterParams) {
    //operator:operator, value:value, type:type, typeparam:typeparam
    //~~ selected:selected, placeholder:placeholder, bucket:bucket
    //markpoint
    //not sure how efficient this is. Wondering if there is a better way of doing this
    var value = cell.getValue();
    if (formatterParams != undefined && formatterParams != "") {
      formatterParams.forEach(function (params) {

        if (params.selected == "select") {
          cell.getElement().style.backgroundColor = "rgba(76, 175, 80, 0.3)"
        }

        var passParam = false;
        if (params.placeholder != undefined) {
          if (params.placeholder == "select") {
            cell.getElement().style.backgroundColor = "rgba(76, 175, 80, 0.3)"
            return "";
          }
          return "";
        }

        if (params.operator == "=" && value.toString() == params.value) {
          passParam = true;
        } else if (params.operator == "!=" && value.toString() != params.value) {
          passParam = true;
        } else if (params.operator == "like" && value.includes(params.value)) {
          passParam = true;
        } else if (params.operator == "<" && !isNaN(value) && value < params.value) {
          passParam = true;
        } else if (params.operator == "<=" && !isNaN(value) && value <= params.value) {
          passParam = true;
        } else if (params.operator == ">" && !isNaN(value) && value > params.value) {
          passParam = true;
        } else if (params.operator == ">=" && !isNaN(value) && value >= params.value) {
          passParam = true;
        }

        if (passParam || params.operator == "all" || params.operator == "colselect") {
          cell.getElement().style[params.type] = params.typeparam;
        }
      })
    }

    return value; //return the contents of the cell;
  },
  ColumnTitle: function (cell, formatterParams) {
    // var isChecked;

    // if (formatterParams[2]) {
    // 	isChecked = "checked";
    // } else {
    // 	isChecked = "";
    // }
    // return '<div class="uk-flex uk-flex-middle"><input type="checkbox" class="titleCheckboxes" value=' + formatterParams[0].title + ' onchange="SelectColumnCheck(\'' + formatterParams[0].shortTitle + '\',' + formatterParams[0].price + ')" ' + isChecked + '><span>' + cell.getValue() + '</span></div>';
    return '<div class="titleHeader"><button class="ttlButton" onclick="BuyThisColumn(\'' + cell.getValue() + '\')"><i class="fas fa-shopping-cart"></i></button><span>' + cell.getValue() + '</span></div>';

  },
  ColumnViser: function (cell, formatterParams) {
    return '<div class="titleHeader"><button class="ttlButton" onclick="HideThisColumn(event, \'' + formatterParams + '\')"><i class="far fa-eye-slash"></i></button><span>' + cell.getValue() + '</span></div>';

  },
  dataTitle: function (cell, formatterParams) {
    if (formatterParams.country != "none" && formatterParams.country != undefined) return cell.getValue() + formatterParams.country;
    return cell.getValue();
  },
  emptyPlacer: function (cell, formatterParams, onRendered) {
    //cell - the cell component
    //formatterParams - parameters set for the column
    //onRendered - function to call when the formatter has been rendered

    // if (cell.getValue() === undefined || cell.getValue() === null || cell.getValue() == "") return emptyPlaceholderText;
    if (cell.getValue() === null) return emptyPlaceholderText;
    if (isNaN(cell.getValue())) return cell.getValue(); //return the contents of the cell;
    return +(Math.round(cell.getValue() + "e+" + 2) + "e-" + 2);
  },
  loadingPlacer: function (cell, formatterParams, onRendered) {
    //cell - the cell component
    //formatterParams - parameters set for the column
    //onRendered - function to call when the formatter has been rendered

    // if (cell.getValue() === undefined || cell.getValue() === null || cell.getValue() == "") return emptyPlaceholderText;
    if (cell.getValue() === null) {
      if (app.orderDone == true) return emptyPlaceholderText;
      cell.getElement().style.backgroundColor = "#ff000029";
      return loadingPlaceholderText;
    }
    return cell.getValue(); //return the contents of the cell;
  },
  loadingPlacerSV: function (cell, formatterParams, onRendered) {
    //cell - the cell component
    //formatterParams - parameters set for the column
    //onRendered - function to call when the formatter has been rendered

    // if (cell.getValue() === undefined || cell.getValue() === null || cell.getValue() == "") return emptyPlaceholderText;
    if (cell.getValue() === null) {
      if (app.orderDone == true || cell.getRow().getData()?.SV_Complete == true) return emptyPlaceholderText;
      cell.getElement().style.backgroundColor = "#ff000029";
      return loadingPlaceholderText;
    }
    return cell.getValue(); //return the contents of the cell;
  },
  blurrycell: function (cell, formatterParams, onRendered) {
    //cell - the cell component
    //formatterParams - parameters set for the column
    //onRendered - function to call when the formatter has been rendered
    if (cell.getValue() == undefined) {
      return '<div class="blurryceller"><svg width=16 height=16 xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="level-up-alt" class="svg-inline--fa fa-level-up-alt fa-w-10" role="img" viewBox="0 0 320 512"><path fill="currentColor" d="M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"/></svg></div>'; //return the contents of the cell;
    } else {
      return cell.getValue();
    }
  },
  clicktoview: function (cell, formatterParams, onRendered) {
    //cell - the cell component
    //formatterParams - parameters set for the column
    //onRendered - function to call when the formatter has been rendered
    return "<div style='color:blue'> click to view </div>"; //return the contents of the cell;
  }
});
//? end tabulator additions

window.store = createStore({
  state: {
    count: 0,
    debugOptions: false,
    finishedLoadingPages: false,
    rowCount: 0,
    filterCount: false,
    defaultName: "",
    cart: [],
    reports: {},
    purchasing: [],
    pages: [
      {
        title: "Keyword Table",
        active: true,
        code: "keywords",
        name: "Keywordtable",
        component: { template: "<div></div>" },
      },
    ],
    activePage: {
      title: "Keyword Table",
      active: true,
      code: "keywords",
      name: "Keywordtable",
      component: { template: "<div></div>" },
    },
    groups: [],
    pivotTables: [],
    notes: [],
    settings: {
      easyColumns: true,
      striped: true,
      sideboxhover: false,
      singleClickKeywords: true,
    },
    sidebar: {
      display: false,
      content: "keyword-report",
    },
    displayKeyword: {
      keywordOfNote: {},
      stats: { "keyword_data": false, "serp_results": false, "exact_serp_results": false },
    },
    sideInfoType: 'url',
    displayUrl: {
      urlOfNote: {},
      stats: [],
      type: 'url',
      urls: [],
    },
    breadCrumbsSideNotes: [],
    recentSideNotes: [],
    modal: {
      display: false,
      content: "new-project",
    },
    urls: {
      list: [],
      setList: new Set(),
    },
    domains: {
      list: [],
      setList: new Set(),
    },
    columns: [],
    urlColumns: [],
    domainColumns: [],
    filters: [],
    sorters: [],
    project: {
      hash: "",
      name: "Loading Title",
      sample: false,
      shared: false,
      purchase_history: [],
      purchaseTypes: { "keyword_data": false, "serp_results": false, "exact_serp_results": false },
    },
    addKeys: [],
    addKeyDetails: {},
    templates: {},
    savingTree: {
      whatSave: [],
      layout: false,
      saving: false,
      urls: false,
      domains: false,
      urlTableSettings: { on: false, filters: [], sorters: [], columns: [] },
      urlCustomColumns: [],
      domainTableSettings: { on: false, filters: [], sorters: [], columns: [] },
      domainCustomColumns: [],
      add_keywords: [],
      add_to_keywords: {},
      add_to_keywords_all: [],
      update_keywords: {},
      delete_keywords: [],
      columns: {
        formula: [],
        imported: [],
      },
      pages: false,
      pivot_table: {
        new: [],
        update: [],
      },
      groups: {
        new: [],
        update: [],
      },
      features: {
        new: [],
        update: [],
      },
      settings: {},
    },
    newProjectKeywords: [],
    projects: [],
    projectviewerfunctions: "open",
    projectviewerkeywords: "all",
    deepColumns: {},
  },
  getters: {
    usefulColumns(state) {
      return state.columns.filter(IsUsefulColumnFilter);
    },
    colFieldTitleDict(state, getters) {
      var dictTemp = {};
      state.columns.forEach(function (item) {
        dictTemp[item?.field] = item?.title;
      });
      return dictTemp;
    },
    listColumns(state) {
      return state.columns.filter(IsListColumnFilter);
    },
    reportsNames(state) {
      var reportsNames = {};
      Object.keys(state.reports).forEach(function (key) {
        if (state.reports[key].hidden != true) {
          reportsNames[key] = state.reports[key];
        }
      });
      return reportsNames;
    },
  },
  mutations: {
    //cart
    AddToCart(state, item) {
      if (item.form == "purchaseItem") state.cart.push(item);
      if (item.form == undefined) state.cart.push(new purchaseItem(item));
    },
    RemoveFromCart(state, itemIndex) {
      if (item.indexPosition != undefined) {
        state.cart.splice(itemIndex, 1);
        return;
      }
      state.cart.splice(positionInCart(state.cart, item), 1);
    },
    ResetCart(state, item) {
      state.cart = [];
    },
    SetCart(state, itemArray) {
      state.cart = itemArray;
    },
    SetPurchasing(state, itemArray) {
      state.purchasing = itemArray;
      // store.commit("showModal", "purchasing-card");
      buyCart();
    },
    JustSetPurchReport(state, itemArray) {
      //don't use, for specific case
      state.purchasing = itemArray;
    },
    increment(state) {
      state.count++;
    },


    //sidebar and modal
    showModal(state, content = false) {
      console.log("showModal", content)
      if (content !== false) state.modal.content = content;
      OpenModal("componentModal");
    },
    toggleSide(state, content = false) {
      if (content !== false) state.sidebar.content = content;
      state.sidebar.display = !state.sidebar.display;
      if (!state.sidebar.display) RemoveParam("kw");
    },
    showSide(state, content = false) {
      if (content !== false) state.sidebar.content = content;
      state.sidebar.display = true;
    },
    hideSide(state) {
      RemoveParam("kw");
      state.sidebar.display = false;
    },
    keywordClicked(state, info) {
      let row;
      let source;
      if (info?.source != undefined) {
        row = info.row;
        source = info?.source ?? { type: 'base', id: 'base' }
      } else {
        row = info;
        source = { type: 'base', id: 'base' }
      }
      if (row == undefined) return;
      var keywordInfo = row;
      if (row._row != undefined) {
        keywordInfo = row.getData();
      }
      state.displayKeyword.keywordOfNote = keywordInfo;
      state.displayKeyword.stats = { "keyword_data": false, "serp_results": false, "exact_serp_results": false };

      //breadcrumb tracking
      if (info?.skipBread !== true) store.commit("breadCrumbManager", { type: 'keyword', id: keywordInfo.keyword, itemInfo: keywordInfo, source: { type: source?.type, id: source?.id } })


      PopulateSideBar(keywordInfo);
      AddorUpdateParam({ "kw": keywordInfo.keyword });
      store.commit("showSide", "keyword-report");
    },
    UrlClicked(state, info) {
      let row = info.row;
      let type = info.type;
      var source = info?.source;
      if ((row == -1 || row == undefined) && info.url != undefined) row = { url: info.url };
      if (row == undefined && info.url == undefined) return;
      var keywordInfo = row;
      if (row._row != undefined) {
        keywordInfo = row.getData()
        source = { type: 'base', id: 'base' }
      }
      state.displayUrl.urlOfNote = keywordInfo;
      state.displayUrl.stats = [];
      state.displayUrl.urls = [];
      state.displayUrl.type = type;

      //start requests for data
      DisplayUrl(keywordInfo, type);

      if (info?.skipBread !== true) store.commit("breadCrumbManager", { type: type, id: keywordInfo[type], itemInfo: keywordInfo, source: { type: source?.type, id: source?.id } })
      store.commit("showSide", "url-report");
    },
    breadCrumbManager(state, info) {
      // console.log('bread', info)
      //handle recents first
      state.recentSideNotes.unshift(info)
      if (state.recentSideNotes.length > 10) state.recentSideNotes.pop();

      //handle breadcrumb
      //--handle start of new trail
      if (info.source == undefined) info.source = { type: 'base' }
      if (info.source.type == 'base') {
        state.breadCrumbsSideNotes = [info];
      } else {
        let i = 0;
        let found = false;
        //run through for finding where to put crumbs
        while (found == false && i < state.breadCrumbsSideNotes.length) {
          var item = state.breadCrumbsSideNotes[i];
          if (item.type == info.source.type && item.id == info.source.id) {
            found = true;
            state.breadCrumbsSideNotes.splice(i + 1, state.breadCrumbsSideNotes.length - i, info);
          }
          i++;
        }
        //just put in crumb
        if (found == false) {
          state.breadCrumbsSideNotes.push(info);
        }
      }
    },
    SetToBreadcrumb(state, info) {
      let index = info.index;
      let bread = state.breadCrumbsSideNotes[index];
      //remove all after index
      state.breadCrumbsSideNotes.splice(index + 1, state.breadCrumbsSideNotes.length - 1);

      //open related crumb
      if (bread.type == 'keyword') {
        store.commit("keywordClicked", { row: bread.itemInfo, source: bread.source, skipBread: true });
      } else {
        store.commit("UrlClicked", { row: bread.itemInfo, type: bread.type, source: bread.source, skipBread: true });
      }
    },
    SetToRecentcrumb(state, info) {
      let index = info.index;
      let bread = state.recentSideNotes[index];
      //open related crumb
      if (bread.type == 'keyword') {
        store.commit("keywordClicked", { row: bread.itemInfo, source: bread.source, skipBread: true });
      } else {
        store.commit("UrlClicked", { row: bread.itemInfo, type: bread.type, source: bread.source, skipBread: true });
      }
    },
    RefreshKeywordOfNote(state) {
      var index = state.displayKeyword.keywordOfNote.index;
      state.displayKeyword.keywordOfNote = tableData.find(ele => ele.index == index);
    },
    storeKeywordInfo(state, info) {
      //TODO make it only update if it matches. make sure it goes in cache if complete.
      if (state.displayKeyword.keywordOfNote.index == info.index) state.displayKeyword.stats[info.data_type] = info;
    },
    //keyword control feature
    AddKeyDetails(state, info) {
      state.addKeyDetails[info.keyword][info.data_type] = info;
    },
    AddToTopKeywordChart(state, newKey) {
      //ToDo 2323 
      //get keywordRow
      let row = table.getRow(keywordIndexHash[newKey])
      if (state.addKeyDetails[newKey] == undefined) state.addKeyDetails[newKey] = { exact_serp_results: {}, serp_results: {}, keyword_data: {}, main: { new_data: row.getData() } }
      state.addKeys.push(newKey)
      AddKeysDetails(row)
      state.savingTree.saving = true;
      // TODO 2323 load up the keywords data, refresh table on data finished being loaded
    },
    RemoveTopKeywordChart(state, place) {
      if (place > -1) {
        state.addKeys.splice(place, 1)
      }
      state.savingTree.saving = true;
    },
    storeUrlInfo(state, info) {
      if (info.row.url == state.displayUrl.urlOfNote.url) state.displayUrl.stats = info.results;
      if (info.row.url == state.displayUrl.urlOfNote.url && state.displayUrl.urlOfNote.length == 1) state.displayUrl.urlOfNote = info;
    },
    storeDomainInfo(state, info) {
      if (info.row.domain == state.displayUrl.urlOfNote.domain) {
        if (info.results != undefined) state.displayUrl.urls = info.results;
        if (info.keywords != undefined) state.displayUrl.stats = info.keywords;
      }
    },
    //project
    setProject(state, project) {
      state.project = new Project(project);
      // window.history.pushState(
      //   project.id,
      //   project.name + " Sheet",
      //   "/" + project.id
      // );
    },
    setPurchaseHistory(state, purchase_history) {
      console.log("purch", purchase_history)
      state.project.purchase_history = ReturnParsed(purchase_history) ?? [];
      state.project.purchaseTypes = { "keyword_data": false, "serp_results": false, "exact_serp_results": false };
      state.project.purchase_history.forEach(function (ele) {
        if (ele["exact-serp"]) state.project.purchaseTypes["exact_serp_results"] = true;
        if (ele["serp"]) state.project.purchaseTypes["serp_results"] = true;
        if (ele["sv_cpc"]) state.project.purchaseTypes["keyword_data"] = true;
      });
    },
    SetReports(state, reports) {
      state.reports = reports;
    },
    toggleShare(state, setting = "toggle") {
      if (setting == "toggle") {
        state.project.shared = !state.project.shared;
        return;
      }
      state.project.shared = setting;
    },
    save(state, where) {
      // console.log(where);
      // state.whatSave.push(where);
      state.savingTree.saving = true;
    },
    saveATable(state, info) {
      state.savingTree[info.table + "TableSettings"].on = true;
      var statof = info.data;
      if (info.type == 'sorters') statof = info.data.map(function (ele) { return { field: ele.field, dir: ele.dir } });
      if (state.savingTree[info.table + "TableSettings"][info.type].length != statof.length) state.savingTree[info.table + "TableSettings"][info.type] = statof;
      state.savingTree.saving = true;
    },
    ResetSaveATable(state, info) {
      if (info.type == 'url') state.savingTree.urlCustomColumns = info.col;
      if (info.type == 'domain') state.savingTree.domainCustomColumns = info.col;
    },
    stopSave(state) {
      state.savingTree.saving = false;
    },
    saveComplex(state, info) {
      var where = info.where;
      var what = info.what;
      var how = info.how ?? 'array';
      // state.whatSave.push(where);
      if (how == 'direct') {
        state.savingTree[where] = what;
        state.savingTree.saving = true;
        return
      }
      state.savingTree[where].push(what);
      state.savingTree.saving = true;
    },
    saveAddToKeywords(state, info) {
      var where = info.where;
      var what = info.what;
      if (state.savingTree.add_to_keywords[where] == undefined) {
        state.savingTree.add_to_keywords[where] = [];
      }
      state.savingTree.add_to_keywords[where].push(what);
      state.savingTree.saving = true;
    },
    resetTree(state) {

      state.savingTree.saving = false;
      // state.savingTree = {
      //   layout: false,
      //   saving: false,
      //   add_keywords: [],
      //   add_to_keywords: {},
      //   add_to_keywords_all: [],
      //   update_keywords: {},
      //   delete_keywords: [],
      //   columns: {
      //     formula: [],
      //     imported: [],
      //   },
      //   pages: false,
      //   pivot_table: {
      //     new: [],
      //     update: [],
      //   },
      //   groups: {
      //     new: [],
      //     update: [],
      //   },
      //   features: {
      //     new: [],
      //     update: [],
      //   },
      //   settings: {},
      // };
    },
    DummyData(state) {
      var i = 0;
      for (i = 0; i < 4; i++) {
        var dummyUse = Math.floor(Math.random() * 3); //The maximum is exclusive and the minimum is inclusive
        var newColumn = store.dispatch("newColumn", {
          type: "dummydata",
          muta: "dummyData",
          passParam: { type: dummyUse },
          title: "Dummy" + "-" + dummyUse + "-" + i,
        });
      }
      AlertBox("warning", "DummyData Will Not Be Saved");
    },

    //columns and table
    updateColumns(state) {
      state.columns = table.getColumnDefinitions();
    },
    ToggleColumnVis(state, what) {
      table.getColumn(what).toggle();
      var colFlip = state.columns.find(
        (element) => element.field == what
      );
      if (colFlip.visible == undefined) colFlip.visible = true;
      colFlip.visible = !colFlip.visible;
    },
    setFilter(state, filters) {
      state.filters = filters;
      state.savingTree.saving = true;
    },
    setSorter(state, sorters) {
      state.sorters = sorters;
      state.savingTree.saving = true;
    },
    rowCount(state) {
      var count = tableData.length;
      state.rowCount = count;
      if (state.filterCount == false) state.filterCount = count;
    },
    filterCount(state, number) {
      state.filterCount = number;
    },
    //change settings
    SetSettings(state, changeSettings) {
      var newSettings = Object.assign(state.settings, changeSettings);
      state.settings = newSettings;
      if (state.settings.striped == false) {
        document.documentElement.style.setProperty("--zibra", "initial");
      } else {
        document.documentElement.style.setProperty("--zibra", "#efefef");
      }
    },
    startingColumns(state, info) {
      if (info[0].length > 0) state.urlColumns = info[0]
      if (info[1].length > 0) state.domainColumns = info[1]
    },
    setUpSubTableSettings(state, info) {
      state.savingTree.urlTableSettings = info.url;
      state.savingTree.domainTableSettings = info.domain;
    },
    toggleExpand(state) {
      state.settings.expandedbox = !state.settings.expandedbox;
    },

    //pages
    setUpPages(state, pagess) {
      if (pagess.pages == undefined) return;
      var pages = pagess.pages;
      pages.forEach(function (item) {
        if (item.items != undefined) {
          var newItems = item.items.map(function (element) {
            // if (element.type == 'pivotTable')
            if (element.type == 'urls-display') {
              load_product_urls(false)
              return { "type": "urls-display" }
            }
            if (element.type == 'domains-display') {
              load_product_domains(false)
              return { "type": "domains-display" }
            }
            return state[element.type].find((thing) => thing.id == element.id);
          }, this);
          item.items = newItems;
        }
        if (item.code != "keywords") {
          item.loaded = false;
          state.pages.push(item);
        }
      });
      if ((pagess.urls == undefined || pagess.urls == false) && (pagess.domains == undefined || pagess.domains == false)) state.finishedLoadingPages = true;
    },
    NoPages(state) {
      state.finishedLoadingPages = true;
    },
    changePage(state, tabToOpen) {
      if (tabToOpen == "last") tabToOpen = state.pages.length - 1;
      if (state.pages[tabToOpen].active == true) return;
      if (state.finishedLoadingPages == false) {
        return;
      }

      state.pages.forEach(function (element, index) {
        if (index != tabToOpen) state.pages[index].active = false;
        if (index == tabToOpen) {
          state.activePage = state.pages[tabToOpen];
          state.pages[tabToOpen].active = true;
          state.pages[tabToOpen].loaded = true;
        }
      }, this);
    },
    newPage(state, info) {
      info = info ?? {};
      info.items = info.items ?? [];
      if (info.stockTab != undefined) {
        if (info.stockTab == "Groups Panel") {
          info.title = "Group Panel";
          state.groups.forEach(function (group) {
            info.items.push(group);
          }, this);
        }
        if (info.stockTab == "Pivot Table Panel") {
          info.title = "Pivot Table Panel";
          state.pivotTables.forEach(function (group) {
            info.items.push(group);
          }, this);
        }
        if (info.stockTab == "Notes") {
          info.title = "Notes";
        }
      }

      state.pages.push(new Page(info));

      if (info.noFollow == undefined) store.commit("changePage", "last");
      state.savingTree.pages = true;
      state.savingTree.saving = true;
    },
    CreateStockPage(state, tabType) {
      if (tabType == "sheeting") {
      } else if (tabType == "notes") {
        store.commit("newPage");
        state.pages.push({
          title: "Notes",
          active: false,
          code: "notes-gen",
          items: [{ type: "notes", text: "" }],
        });
        store.commit("changePage", "last");
      } else if (tabType == "Data History") {
      } else if (tabType == "Groups panel") {
        state.pages.push({
          title: "Keyword Groups",
          active: false,
          code: "groups-gen",
          items: [],
        });
        store.commit("changePage", "last");
      } else if (tabType == "chart") {
      } else if (tabType == "Pivot Table") {
        state.pages.push({
          title: "Pivot Tables",
          active: false,
          code: "pivots-gen",
          items: [],
        });
        store.commit("changePage", "last");
      } else if (tabType == "Urls Table") {
        state.pages.push({
          title: "Urls Table",
          active: false,
          code: "urlTable",
          items: [{ type: "urls-display" }],
        });
        store.commit("changePage", "last");
      } else if (tabType == "Domains Table") {
        state.pages.push({
          title: "Domains Table",
          active: false,
          code: "domainTable",
          items: [{ type: "domains-display" }],
        });
        store.commit("changePage", "last");
      }
      state.savingTree.pages = true;
      state.savingTree.saving = true;
    },
    groupPage(state) {
      state.pages.push(
        new Page({
          title: state.groups[state.groups.length - 1].title,
          code: "group-gen",
          items: [state.groups[state.groups.length - 1]],
        })
      );
      store.commit("changePage", "last");
      state.savingTree.pages = true;
      state.savingTree.saving = true;
    },
    DuplicatePages(state, tabToCopy) {
      var copytab = state.pages[tabToCopy];
      var newItems = copytab.items.map((ele) => ele);
      store.commit("newPage", {
        title: "duplicate " + copytab.title,
        active: false,
        code: copytab.code,
        items: newItems,
      });
    },
    DeletePage(state, tabToDelete) {
      state.pages.splice(tabToDelete, 1);
      state.savingTree.pages = true;
      state.savingTree.saving = true;
      store.commit("changePage", "last");
    },
    AddRecentlyCreatedToActive(state, what) {
      var whatAdd = state.activeTab.items.push(
        state[what][state[what].length - 1]
      );
      state.savingTree.pages = true;
      state.savingTree.saving = true;
    },
    RemoveFromActivePage(state, info) {
      var where = info;
      state.activePage.items.splice(where, 1);
      state.savingTree.pages = true;
      state.savingTree.saving = true;
    },
    AddToActivePage(state, info) {
      var what = info.what;
      var newItem = info.newItem;

      if (what == "pivotTables") {
        if (newItem === true) {
          store.commit('generatePivotTable', {});
          state.activePage.items.push(
            state.pivotTables[state.pivotTables.length - 1]
          );
        } else {
          state.activePage.items.push(
            state.pivotTables[info.index]
          );
        }
      } else if (what == "groups") {
        if (newItem === true) {
          console.log("how?");
        } else {
          console.log(this.cards.metaCard.groups[newItem]);
          this.activePage.items.push(this.cards.metaCard.groups[newItem]);
        }
      }
      state.savingTree.pages = true;
      state.savingTree.saving = true;
    },
    RenamePage(state, info) {
      console.log(info);
      var newtitle = info.newtitle;
      var tabToRename = info.tabToRename;

      state.pages[tabToRename].title = newtitle;
      state.savingTree.pages = true;
      state.savingTree.saving = true;
    },

    // groups
    setUpGroups(state, groupss) {
      state.groups = [];
      var keywordict = {};
      if (groupss == undefined) return;
      var groups = groupss;
      var keywordsChart = tableData;
      keywordsChart.forEach(function (argument, indexer) {
        keywordict[argument.index] = indexer;
      });
      groups.forEach(function (item) {
        var newGroup = item;
        newGroup.tableID = tableID++;
        if (item.dataType == 'keyword') {
          var newData = newGroup.data.map(function (element) {
            return keywordsChart[keywordict[element]];
          });
          newGroup.data = newData;
        }
        state.groups.push(newGroup);
        if (newGroup.expanded == true && item.dataType == 'keyword') {
          console.log('groupLoading')
          store.dispatch("ExpandGroup", newGroup.id)
        }
      });
    },
    GroupSelectedRowsUrl(state, info) {
      let alert = info.info;
      let tableof = info.row.getTable();
      var selectedRows = tableof.getSelectedRows();
      if (selectedRows.length == 0) {
        AlertBox({ status: "danger", message: "no rows selected" });
        return;
      }
      let type = "url";

      var selectedData = GetSelectedTableDataSpecific(tableof);
      var newGroup = new Group({ dataType: tableof.options.dataType, data: selectedData });
      state.groups.push(newGroup);
      // state.savingTree.groups.new.push(newGroup);
      state.savingTree.saving = true;
      if (alert) CreateAlert("Group created. Create new page?", 10000, "function", 'groupPageWrap')
    },
    GroupSelectedRows(state, alert = true) {
      var selectedRows = table.getSelectedRows();
      if (selectedRows.length == 0) {
        AlertBox({ status: "danger", message: "no keywords selected" });
        return;
      }
      var selectedData = GetSelectedTableData();
      var newGroup = new Group({ data: selectedData });
      state.groups.push(newGroup);
      // state.savingTree.groups.new.push(newGroup);
      state.savingTree.saving = true;
      if (alert) CreateAlert("Group created. Create new page?", 10000, "function", 'groupPageWrap')
    },
    GroupByFormula(state, info) {
      //todo 2323 mutalook
      let dataSource = info.dataSource;
      let dataType = info.dataType ?? 'keyword';
      var selectedRows = dataSource.filter(element => parserer(info.params, element) == true);
      if (selectedRows.length == 0) {
        AlertBox({ status: "danger", message: "no keywords selected" });
        return;
      }
      var newGroup = new Group({ data: selectedRows, title: info.title, dataType: dataType });
      state.groups.push(newGroup);
      // state.savingTree.groups.new.push(newGroup);
      state.savingTree.saving = true;
      if (info.alert === true) CreateAlert("Group created. Create new page?", 10000, "function", 'groupPageWrap')
    },
    GroupByArray(state, info) {
      //todo make this
      var newGroup = new Group(info);
      state.groups.push(newGroup);
      // state.savingTree.groups.new.push(newGroup);
      state.savingTree.saving = true;
    },
    groupCalculateStats(state, groupID) {
      var Group = state.groups.find((element) => element.id == groupID);
      Group.statsResults = Group.statistics.map(function (element) {
        return statisticsCalc[element.type].call({
          field: element.field,
          data: Group.data,
        });
      }, this);
    },

    groupstatchangeadd(state, params) {
      var Group = state.groups.find(
        (element) => element.id == params.groupNumber
      );
      Group.statistics.push({ type: params.type, field: params.field });
      // state.savingTree.groups.update.push({
      //   id: params.groupNumber,
      //   change: "statistics",
      //   statistics: Group.statistics,
      // });
      state.savingTree.saving = true;
      this.commit("groupCalculateStats", params.groupNumber);
    },
    groupstatchangeremove(state, params) {
      var Group = state.groups.find(
        (element) => element.id == params.groupNumber
      );
      Group.statistics.splice(params.whichStat, 1);
      // state.savingTree.groups.update.push({
      //   id: params.groupNumber,
      //   change: "statistics",
      //   statistics: Group.statistics,
      // });
      state.savingTree.saving = true;
      this.commit("groupCalculateStats", params.groupNumber);
    },
    grouptitlechange(state, infouse) {
      state.groups.forEach(function (element) {
        if (element.id == infouse.id) {
          element.title = infouse.title;
          // state.savingTree.groups.update.push({
          //   id: infouse.id,
          //   change: "title",
          //   title: infouse.title,
          // });
        }
      }, this);
    },
    removeKeywordsFromGroup(state, info) {
      var keywords = info.keywords;
      var groupID = info.groupID;
      var group = state.groups.find((element) => element.id == groupID);

      var deleteIndexDict = {};
      keywords.forEach(function (element) {
        deleteIndexDict[element.index] = 2;
      });

      var returnArray = [];
      var returnArray = group.data.filter(function (element) {
        return deleteIndexDict[element.index] != 2;
      });
      group.data = returnArray;
      group.rowAmount = returnArray.length;

      store.commit("groupCalculateStats", groupID);

      // state.savingTree.groups.update.push({
      //   id: group.id,
      //   change: "data",
      //   data: returnArray,
      // });
      state.savingTree.saving = true;
    },
    AddGroupColumn(state, info) {
      var groupID = info.groupID;
      var group = state.groups.find((element) => element.id == groupID);
      group.customCol.push(info.genColumn);
      let spaceOff = group.dataType == 'keyword' ? 3 : 4;
      group.columnManager = info.columns.toSpliced(spaceOff, 0, info.genColumn);
      group.updateCount = group.updateCount + 1;
      state.savingTree.saving = true;
    },
    groupcolumnchange(state, params) {
      var groupID = params.groupID;
      var group = state.groups.find((element) => element.id == groupID);
      group.columnManager = params.columns;
      state.savingTree.saving = true;
    },

    // urls and domains
    // domains and urls
    ResetUrls(state) {
      state.urls.list = [];
    },
    AddUrls(state, info) {
      let urls = info.urls;
      let pushItem = urls.filter(item => {
        const duplicate = store.state.urls.setList.has(item.id);
        store.state.urls.setList.add(item.id);
        return !duplicate;
      });

      state.urlColumns.forEach(function (genColumn) {
        if (genColumn.muta != undefined) {
          pushItem = pushItem.map(function (element, index) {
            var rowUpdate = { index: element.index };
            rowUpdate[genColumn.field] = mutatorDoes[genColumn.muta].call({
              data: element,
              params: genColumn.mutaParams,
            });
            return Object.assign(element, rowUpdate);
          });
        }
      })

      state.urls.list = state.urls.list.concat(pushItem)
      state.savingTree.urls = true;
      if (info.done == true) AfterUrls();
    },

    ResetDomains(state) {
      state.domains.list = [];
    },
    AddDomains(state, info) {
      let urls = info.urls;
      let pushItem = urls.filter(item => {
        const duplicate = store.state.domains.setList.has(item.id);
        store.state.domains.setList.add(item.id);
        return !duplicate;
      });

      state.domainColumns.forEach(function (genColumn) {
        if (genColumn.muta != undefined) {
          pushItem = pushItem.map(function (element, index) {
            var rowUpdate = { index: element.index };
            rowUpdate[genColumn.field] = mutatorDoes[genColumn.muta].call({
              data: element,
              params: genColumn.mutaParams,
            });
            return Object.assign(element, rowUpdate);
          });
        }
      })

      state.domains.list = state.domains.list.concat(pushItem)
      state.savingTree.domains = true;
      if (info.done == true) AfterDomains();
    },

    LoadedUrlsDeep(state, typeOfIt) {
      //set up groups of url or domain type
      state.finishedLoadingPages = true;
      state.groups.map(function (ele) {
        if (ele.dataType == typeOfIt) {
          var base = state[ele.dataType + 's'].list;
          var newData = ele.data.map(function (element) {
            if (base[element - 1] && base[element - 1].id == element) return base[element - 1];
            return base.find(ele => ele.id == element);
          });
          ele.data = newData;
          return ele
        }
        return ele
      })
      state.groups.forEach(function (item) {
        if (item.dataType == typeOfIt && item.expanded == true) {
          console.log('groupLoading')
          store.dispatch("ExpandGroup", item.id)
        }
      });

      //set up pivot tables of url or domain type
      state.pivotTables.map(function (item) {
        var newTable = item;
        if (item.dataType == typeOfIt && newTable.source == "url") {
          newTable.data = PivotGroupBy(state.urls.list, newTable.groups);
          return newTable;
        } else if (item.dataType == typeOfIt && newTable.source == "domain") {
          newTable.data = PivotGroupBy(state.domains.list, newTable.groups);
          return newTable;
        } else if (item.dataType == typeOfIt && newTable.source == 'group') {
          newTable.data = PivotGroupBy(
            state.groups.find((element) => element.id == newTable.sourceID).data,
            newTable.groups
          );
          return newTable
        }
        return newTable;
      }, this);
    },

    //features
    setUpFeatures(state, info) {
      if (info == undefined) return;
      info.forEach(function (item) {
        state[item.type].push(item)
      })
    },
    GenerateNote(state, note) {
      note = note ?? {};
      state.notes.push(new Note(note));

      if (note.newPage)
        store.commit("newPage", {
          title: "new note",
          active: false,
          code: "note-gen",
          items: [state.notes[state.notes.length - 1]],
        });
      state.savingTree.saving = true;
    },
    UpdateNote(state, note) {
      var editNote = state.notes.find((ele) => ele.id == note.id);
      Object.keys(note).forEach(function (item) {
        if (item != "id") editNote[item] = note[item];
      });
      state.savingTree.saving = true;
    },
    //pivot tables
    setUpPivots(state, pivot) {
      if (pivot == undefined) return;
      var pivotTables = pivot;
      pivotTables.forEach(function (item) {
        var newTable = item;
        if (newTable.source == "table") {
          newTable.data = PivotGroupBy(tableData, newTable.groups);
        } else if (newTable.dataType == 'keyword') {
          newTable.data = PivotGroupBy(
            state.groups.find((element) => element.id == newTable.sourceID).data,
            newTable.groups
          );
        }
        state.pivotTables.push(newTable);
      }, this);
    },
    addkeywordgrouppivottable(state, groupId) {
      let sourceGroup = state.groups.find((element) => (element.id == groupId))
      var newPivot = new PivotTable({
        sourceID: groupId,
        source: "group",
        data: sourceGroup.data,
        dataType: sourceGroup.dataType,
      });
      state.pivotTables.push(newPivot);
      state.savingTree.pivot_table.new.push(newPivot);
      state.savingTree.saving = true;
    },
    generatePivotTable(state, pivot) {
      //groups, columns, data
      console.log(pivot);
      var newPivot = new PivotTable(pivot);
      state.pivotTables.push(newPivot);
      state.savingTree.pivot_table.new.push(newPivot);
      state.savingTree.saving = true;


      // add table to new page
      if (pivot.newPage == true)
        store.commit("newPage", {
          title: "new pivot table",
          active: false,
          code: "pivot-gen",
          items: [state.pivotTables[state.pivotTables.length - 1]],
        });

      CloseModal('componentModal')
    },
    addGroupToPivotTable(state, pivot) {
      var pivotID = pivot.id;
      var pivotTable = state.pivotTables.find(
        (element) => element.id == pivotID
      );
      var column = "";
      if (pivot.structure == 'table') {
        column = state.columns.find(
          (element) => element.field == pivot.field
        );
      }
      if (pivot.structure == 'url') {
        column = state.urlColumns.find(
          (element) => element.field == pivot.field
        );
      }
      if (pivot.structure == 'domain') {
        column = state.domainColumns.find(
          (element) => element.field == pivot.field
        );
      }

      //add group to field list and columns
      pivotTable.groups.push(pivot.field);
      pivotTable.columns.splice(pivotTable.groups.length - 1, 0, {
        field: pivot.field,
        title: column.title,
        visible: true,
        formatter: "pivotGroupFormat",
      });

      //recalculate data
      var data = tableData;
      if (pivotTable.source == "group" || pivotTable.source == "selected")
        data = state.groups.find(
          (element) => element.id == pivotTable.sourceID
        ).data;
      pivotTable.data = PivotGroupBy(data, pivotTable.groups);

      //saving
      state.savingTree.pivot_table.update.push({
        id: pivotID,
        change: "groups",
        groups: pivotTable.groups,
      });
      state.savingTree.pivot_table.update.push({
        id: pivotID,
        change: "columns",
        columns: pivotTable.columns,
      });
      state.savingTree.saving = true;
    },
    removeGroupFromPivotTable(state, pivot) {
      var pivotID = pivot.id;
      var pivotTable = state.pivotTables.find(
        (element) => element.id == pivotID
      );

      //remove form field list and columns
      var removedField = pivotTable.groups.splice(pivot.index, 1);
      var removedColumn = pivotTable.columns.findIndex(
        (element) => element.field == removedField[0]
      );
      pivotTable.columns.splice(removedColumn, 1);

      //recalcuate data
      var data = tableData;
      if (pivotTable.source == "group" || pivotTable.source == "selected")
        data = state.groups.find(
          (element) => element.id == pivotTable.sourceID
        ).data;
      pivotTable.data = PivotGroupBy(data, pivotTable.groups);

      //saving
      state.savingTree.pivot_table.update.push({
        id: pivotID,
        change: "groups",
        groups: pivotTable.groups,
      });
      state.savingTree.pivot_table.update.push({
        id: pivotID,
        change: "columns",
        columns: pivotTable.columns,
      });
      state.savingTree.saving = true;
    },
    addColumnToPivotTable(state, pivot) {
      var pivotID = pivot.id;
      var pivotTable = state.pivotTables.find(
        (element) => element.id == pivotID
      );
      var column = state.columns.find(
        (element) => element.field == pivot.field
      );

      //make unique field name then add to columns
      var fieldID = pivotTable.columns.length;
      var check = true;
      while (check) {
        var hazerd = pivotTable.columns.findIndex(
          (element) => element.field == column.field + " " + fieldID
        );
        if (hazerd >= 0) fieldID++;
        if (hazerd < 0) check = false;
      }

      pivotTable.columns.push({
        field: column.field + " " + fieldID,
        title: pivot.calc.value + " of " + column.title,
        visible: true,
        mutator: "customListMutator",
        mutatorParams: {
          type: pivot.calc.code,
          field: column.field,
          dataField: "rows",
        },
      });

      //saving
      state.savingTree.pivot_table.update.push({
        id: pivotID,
        change: "columns",
        columns: pivotTable.columns,
      });
      state.savingTree.saving = true;
    },
    removeColumnFromPivotTable(state, pivot) {
      var pivotID = pivot.id;
      var pivotTable = state.pivotTables.find(
        (element) => element.id == pivotID
      );

      //remove from columns
      pivotTable.columns.splice(pivot.index, 1);

      //saving
      state.savingTree.pivot_table.update.push({
        id: pivotID,
        change: "columns",
        columns: pivotTable.columns,
      });
      state.savingTree.saving = true;
    },

    //misc
    NewProjectKeywords(state, array) {
      state.newProjectKeywords = array;
    },
    DBUGON(state) {
      state.debugOptions = true;
    },
    SetTemplates(state, templates) {
      state.templates = templates;
    },

    //settings
    ChangeStripe(state) {
      state.settings.striped = !state.settings.striped;
      if (state.settings.striped == false) {
        document.documentElement.style.setProperty("--zibra", "initial");
      } else {
        document.documentElement.style.setProperty("--zibra", "#efefef");
      }
      table.redraw(true);
      state.savingTree.settings.striped = state.settings.striped;
      state.savingTree.saving = true;
    },
    toggleSideSetting(state) {
      state.settings.sideboxhover = !state.settings.sideboxhover;
    },
    changeKeywordClicks(state, setting) {
      state.settings.singleClickKeywords = setting;
    },
    easyColumns(state, setting) {
      state.settings.easyColumns = setting;
      if (setting == false) {
        //hide them
        table.getColumns().forEach(function (element) {
          if (element.getDefinition().easyCol === true) {
            element.hide();
          }
        });
      } else {
        //reveal them
        table.getColumns().forEach(function (element) {
          if (element.getDefinition().easyCol === true) {
            element.show();
          }
        });
      }
    },
    SetProjectsList(state, list) {
      state.projects = list;
    }
  },
  actions: {
    ExpandGroup({ commit, state }, groupID) {
      let group = state.groups.find((element) => element.id == groupID);
      group.expanded = true;
      group.loadingExpanded = true;
      let curr_keyword = group.data.map((element) => element[group.dataType]);

      state.project.purchase_history.forEach(function (itemof) {
        post_request(
          '/v1/load_many_' + group.dataType + '_report',
          JSON.stringify({ 'projectHash': projectHash, type: group.dataType, 'list': curr_keyword, "id": itemof.id }),
          function (data) {
            console.log('groupID: ' + group.id + ' expanded')
            group.loadingExpanded = false;
            group.data = group.data.map(function (element, index) {
              // let newdata = Object.keys(data[index]).filter(function (key) {
              //   if (Object.keys(key).length > 0) return true;
              //   return false;
              // })
              // console.log(newdata)
              return Object.assign(element, data[index])
            })

            // if (project_done) {
            // 	keyword_data_cache[data_type][curr_keyword][id] = data;
            // }
            // if(tickerFresh == true){
            // 	store.commit("AddKeyDetails", { new_data:data, curr_product, index: row._row.data.index, keyword: row._row.data.keyword, data_node_id, data_type })
            // } else {
            // 	ProcessResults(data, curr_product, row, data_node_id, data_type);
            // }
          },
          function () {
            if (purchases.length != 0) AlertBox("danger", "An error has occurred while loading your project. Please refresh the page. If this problem continues, please contact support.", -1);
          }
        );
        state.savingTree.saving = true;
      });
    },
    openProjects({ commit, state }, settings) {
      post_request(
        '/get_project_list',
        JSON.stringify(),
        function (loadData) {
          console.log(loadData)
          state.projects = loadData.projects;
        },
        function () {
          AlertBox(
            "danger",
            "no project list, please reload the project.",
            -1
          );
          console.log("error");
        }
      );
      state.projectviewerfunctions = settings.functions;
      state.projectviewerkeywords = settings.keywords;
      store.commit("showModal", "project-viewer");
    },
    newColumn({ commit, state }, settings) {

      var type = settings.type;
      console.log(type);
      var title = settings.title;
      var passParam = settings.passParam;
      var visibility = settings.visibility ?? true;
      var fieldNum = table.getColumnDefinitions().length;
      if (settings.dataType == 'url') {
        fieldNum = state.urlColumns.length
        if (state.urlColumns.find((element) => element.title == title) != undefined)
          title = title + "_" + fieldNum;
      }
      if (settings.dataType == 'domain') {
        fieldNum = state.domainColumns.length
        if (state.domainColumns.find((element) => element.title == title) != undefined)
          title = title + "_" + fieldNum;
      }

      //no duplicate title
      if (state.columns.find((element) => element.title == title) != undefined)
        title = title + "_" + fieldNum;


      //make column
      var genColumn = new Column(
        settings.type,
        settings.title,
        settings.passParam,
        fieldNum,
        visibility
      );

      if (settings.dataType == 'sub') {
        return genColumn;
      }

      if (settings.dataType != undefined && settings?.dataType != 'keyword') {

        if (settings.dataType == 'url') {
          state.urlColumns.splice(2, 0, genColumn)
          state.savingTree.urlCustomColumns = state.urlColumns;
        }

        if (settings.dataType == 'domain') {
          state.domainColumns.splice(2, 0, genColumn)
          state.savingTree.domainCustomColumns = state.domainColumns;
        }

        if (genColumn.muta != undefined) {
          state[settings.dataType + 's'].list = state[settings.dataType + 's'].list.map(function (element) {
            var rowUpdate = { index: element.index };
            rowUpdate[genColumn.field] = mutatorDoes[genColumn.muta].call({
              data: element,
              params: genColumn.mutaParams,
            });
            return Object.assign(element, rowUpdate);
          });
        }

        //add to active groups
        state.groups.forEach(function (item) {
          if (item.dataType == 'url' || item.dataType == 'domain') {
            if (item.columnManager.length > 0) item.columnManager.push(genColumn);
          }
        })

        state.savingTree.saving = true;
        return genColumn.field;
      }

      table.addColumn(genColumn);

      //adding mutator data manually

      if (genColumn.muta != undefined) {
        tableData.forEach(function (element) {
          var rowUpdate = { index: element.index };
          rowUpdate[genColumn.field] = mutatorDoes[genColumn.muta].call({
            data: element,
            params: genColumn.mutaParams,
          });
          Object.assign(element, rowUpdate);
        });
        AddedNewData();
      }

      //move ahead of easyCols
      var firstEascol = table
        .getColumns()
        .find((element) => element.getDefinition().easyCol === true);
      if (firstEascol != undefined)
        table.getColumn(genColumn.field).move(firstEascol, false);

      //add columns to already created groups
      state.groups.forEach(function (item) {
        if (item.dataType == 'keyword') {
          if (item.columnManager.length > 0) item.columnManager.push(genColumn);
        }
      })

      //saving and return
      commit("updateColumns");
      state.savingTree.saving = true;
      return genColumn.field;
    },
  },
});


// import "vue-toastification/dist/index.css";

// Vue.use(Toast, {
//   transition: "Vue-Toastification__bounce",
//   maxToasts: 20,
//   newestOnTop: true,
// });

const options = {
  // You can set your default options here
};

import { defineAsyncComponent } from 'vue'

// const HelloWorld = defineAsyncComponent(() =>
//   import('../../components/HelloWorld.vue')
// ) 
import CartCard from "../../components/CartCard.vue";
import ChartCreate from "../../components/ChartCreate.vue";
import ColumnControls from "../../components/ColumnControls.vue";
import ColumnManagement from "../../components/ColumnManagement.vue";
import ColumnSorter from "../../components/ColumnSorter.vue";
import ColumnVisibility from "../../components/ColumnVisibility.vue";
import ConditionalFormatter from "../../components/ConditionalFormatter.vue";
import FilterControls from "../../components/FilterControls.vue";
import FilterControlSub from "../../components/FilterControlSub.vue";
import BreadCrumbControls from "../../components/BreadCrumbControls.vue";
import GroupDisplay from "../../components/GroupDisplay.vue";
import KeywordReport from "../../components/KeywordReport.vue";
import UrlReport from "../../components/UrlReport.vue";
import Locationkeywordgen from "../../components/Locationkeywordgen.vue";
import MarketPlace from "../../components/MarketPlace.vue";
import TemplateMarket from "../../components/TemplateMarket.vue";
import NewProject from "../../components/NewProject.vue";
import NoteDisplay from "../../components/NoteDisplay.vue";
import PageComponent from "../../components/PageComponent.vue";
import PageOptions from "../../components/PageOptions.vue";
import Pastekeywordgen from "../../components/Pastekeywordgen.vue";
import PivotCreate from "../../components/PivotCreate.vue";
import PivotCreateUrls from "../../components/PivotCreateUrls.vue";
import PivotDisplay from "../../components/PivotDisplay.vue";
import ProjectViewer from "../../components/ProjectViewer.vue";
import PurchaseCard from "../../components/PurchaseCard.vue";
import ReportItem from "../../components/ReportItem.vue";
import ReportItemM2 from "../../components/ReportItemM2.vue";
import ScoreColumnCreate from "../../components/ScoreColumnCreate.vue";
import ScoreColumnCreateSub from "../../components/ScoreColumnCreateSub.vue";
import GroupByFilterCreate from "../../components/GroupByFilterCreate.vue";
import SettingsControl from "../../components/SettingsControl.vue";
import SheetKeywords from "../../components/SheetKeywords.vue";
import Substitutionkeywordgen from "../../components/Substitutionkeywordgen.vue";
import TabGraph from "../../components/TabGraph.vue";
import TabTable from "../../components/TabTable.vue";
import TemplateItem from "../../components/TemplateItem.vue";
import ToastOption from "../../components/ToastOption.vue";
import WordSmasher from "../../components/WordSmasher.vue";
import statCard from "../../components/statCard.vue";
import UrlsDisplay from "../../components/UrlsDisplay.vue";
import DomainsDisplay from "../../components/DomainsDisplay.vue";
import QuickDash from "../../components/QuickDash.vue";

window.app = createApp(App)
  .use(Vuex)
  .use(store)
  .component('ChartCreate', ChartCreate)
  .component('ColumnControls', ColumnControls)
  .component('ColumnManagement', ColumnManagement)
  .component('ColumnSorter', ColumnSorter)
  .component('ColumnVisibility', ColumnVisibility)
  .component('ConditionalFormatter', ConditionalFormatter)
  .component('FilterControls', FilterControls)
  .component('FilterControlSub', FilterControlSub)
  .component('BreadCrumbControls', BreadCrumbControls)
  .component('GroupDisplay', GroupDisplay)
  .component('KeywordReport', KeywordReport)
  .component('UrlReport', UrlReport)
  .component('Locationkeywordgen', Locationkeywordgen)
  .component('MarketPlace', MarketPlace)
  .component('TemplateMarket', TemplateMarket)
  .component('NewProject', NewProject)
  .component('NoteDisplay', NoteDisplay)
  .component('PageComponent', PageComponent)
  .component('PageOptions', PageOptions)
  .component('Pastekeywordgen', Pastekeywordgen)
  .component('PivotCreate', PivotCreate)
  .component('PivotCreateUrls', PivotCreateUrls)
  .component('PivotDisplay', PivotDisplay)
  .component('ProjectViewer', ProjectViewer)
  .component('PurchaseCard', PurchaseCard)
  .component('ReportItem', ReportItem)
  .component('ReportItemM2', ReportItemM2)
  .component('ScoreColumnCreate', ScoreColumnCreate)
  .component('ScoreColumnCreateSub', ScoreColumnCreateSub)
  .component('GroupByFilterCreate', GroupByFilterCreate)
  .component('SettingsControl', SettingsControl)
  .component('SheetKeywords', SheetKeywords)
  .component('Substitutionkeywordgen', Substitutionkeywordgen)
  .component('TabGraph', TabGraph)
  .component('TabTable', TabTable)
  .component('TemplateItem', TemplateItem)
  .component('ToastOption', ToastOption)
  .component('WordSmasher', WordSmasher)
  .component('statCard', statCard)
  .component('UrlsDisplay', UrlsDisplay)
  .component('DomainsDisplay', DomainsDisplay)
  .component('QuickDash', QuickDash)
  .mount("#app");
// .use(Toast, {transition: "Vue-Toastification__bounce", maxToasts: 20, newestOnTop: true,})


// const files = require.context("./", true, /\.vue$/i);
// files
//   .keys()
//   .map((key) =>
//     app.component(key.split("/").pop().split(".")[0], files(key).default)
//   );




//dropdownone
// $(".dropdown-menu a.dropdown-toggle").on("click", function (e) {
//   if (!$(this).next().hasClass("show")) {
//     $(this).parents(".dropdown-menu").first().find(".show").removeClass("show");
//   }
//   var $subMenu = $(this).next(".dropdown-menu");
//   $subMenu.toggleClass("show");

//   $(this)
//     .parents("li.nav-item.dropdown.show")
//     .on("hidden.bs.dropdown", function (e) {
//       $(".dropdown-submenu .show").removeClass("show");
//     });

//   return false;

//dropdown
// $(".dropdown-menu a.dropdown-toggle").on("click", function (e) {
//   if (!$(this).next().hasClass("show")) {
//     $(this).parents(".dropdown-menu").first().find(".show").removeClass("show");
//   }
//   var $subMenu = $(this).next(".dropdown-menu");
//   $subMenu.toggleClass("show");

//   $(this)
//     .parents("li.nav-item.dropdown.show")
//     .on("hidden.bs.dropdown", function (e) {
//       $(".dropdown-submenu .show").removeClass("show");
//     });

//   return false;
// });

function IsUsefulColumnFilter(columnDef) {
  if (
    columnDef.hidden !== true &&
    columnDef.useful !== false &&
    columnDef.field != undefined &&
    columnDef.list == undefined
  )
    return true;
  return false;
}

function IsListColumnFilter(columnDef) {
  if (
    columnDef.hidden !== true &&
    columnDef.field != undefined &&
    columnDef.list != undefined
  )
    return true;
  return false;
}



// 
function positionInCart(cart, item) {
  return false;
}

function ReportToCartItem(purchase) {
  return new purchaseItem(purchase);
}
window.purchaseItem = class {
  constructor(purchase) {
    this.form = "purchaseItem";
    this.report = purchase.item;
    if (purchase.keywords == "all") {
      this.keywords = tableData.map((ele) => ele.index);
    } else {
      this.keywords = purchase.keywords;
    }
    if (purchase.options == "default") {
      //complicated
      this.options = app.settings.options;
    } else {
      this.options = purchase.options;
    }
  }
};
window.Template = class {
  constructor(template) {
    this.name = template.name ?? "unnamed";
    this.description = template.description;
    this.necColumns = template.necColumns ?? [];
    this.formulaColumns = template.formulaColumns ?? [];
    this.layout = template.layout ?? {};
    this.replaceColumns = template.replaceColumns ?? false;
    this.items = template.items ?? [];
    this.pages = template.pages ?? [];
  }
}
window.Column = class {
  constructor(type, title, passParam, fieldNum, visible, field, width) {
    fieldNum = fieldNum ?? table.getColumnDefinitions().length;
    visible = visible ?? true;
    // this.resizable = true;

    if (type == "dummydata") {
      this.title = title;
      this.visible = visible;
      this.field = field ?? "dummy_" + fieldNum;
      this.width = width ?? "200";
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.muta = "dummyData";
      this.mutaParams = passParam;
      // this.alignEmptyValues = "bottom";
    }

    if (type == "data") {
      this.title = title;
      this.visible = visible;
      this.width = width ?? "200";
      this.field = field;
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.fieldType = passParam?.fieldType ?? "none";
      // this.titleFormatter = "dataTitle";
      // this.titleFormatterParams = passParams ?? {country:"none", language:"none"};
      this.country = passParam?.country ?? "none";
      this.language = passParam?.language ?? "none";
    }

    if (type == "note") {
      this.title = "Notes";
      this.visible = visible;
      this.field = field ?? "custom_note_" + fieldNum;
      this.width = width ?? "200";
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.editor = "input";
      this.cellEdited = function (cell) {
        var what = { index: cell._cell.row.data.index };
        what[cell._cell.column.field] = cell._cell.value;
        store.commit("saveAddToKeywords", {
          where: cell._cell.column.field,
          what: what,
        });
      };
      this.cellClick = function (e, cell) {
        //e - the click event object
        //cell - cell component
        e.stopPropagation();
      };
    }

    if (type == "import") {
      this.title = title;
      this.visible = visible;
      this.field = field ?? "custom_import_" + fieldNum;
      this.width = width ?? "200";
      this.formatter = "plaintext";
      this.formatterParams = [];
    }

    if (type == "score") {
      console.log(passParam);
      this.title = title;
      this.visible = visible;
      this.field = field ?? "custom_score_" + fieldNum;
      this.width = width ?? "200";
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.muta = "customColumnMutator";
      this.mutaParams = passParam;
      this.mutaNumber = fieldNum;
    }

    if (type == "word") {
      this.title = 'Words';
      this.visible = visible;
      this.field = field ?? "word_count";
      this.width = width ?? "100";
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.titleFormatter = "ColumnViser";
      this.titleFormatterParams = 'word_count';
      // this.muta = "wordCountMutator";
      // this.mutaParams = passParam;
    }

    if (type == "char") {
      this.title = "Letters";
      this.visible = visible;
      this.field = field ?? "char_count";
      this.width = width ?? "100";
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.titleFormatter = "ColumnViser";
      this.titleFormatterParams = 'char_count';
      // this.muta = "charCountMutator";
      // this.mutaParams = passParam;
    }

    if (type == "bucket") {
      this.title = title;
      this.visible = visible;
      this.field = field ?? "custom_bucket_" + fieldNum;
      this.width = width ?? "200";
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.muta = "customBucketMutator";
      this.mutaParams = passParam;
      this.mutaNumber = fieldNum;
    }

    if (type == "aggScore") {
      this.title = title;
      this.visible = visible;
      this.width = width ?? "200";
      this.field = field ?? "custom_aggScore_" + fieldNum;
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.muta = "customListMutator";
      this.mutaParams = passParam;
      this.mutaNumber = fieldNum;
    }

    if (type == "aggScoreSub") {
      this.title = title;
      this.visible = visible;
      this.width = width ?? "200";
      this.field = field ?? "custom_aggSubScore_" + fieldNum;
      this.formatter = "plaintext";
      this.formatterParams = [];
      this.mutator = "customAggMutator";
      this.mutatorParams = passParam;
      this.mutaNumber = fieldNum;
    }

    if (type == "subReport") {
      this.title = title;
      this.visible = false;
      this.field = field ?? "custom_subReport_" + fieldNum;
      this.list = true;
    }
  }
};

class Note {
  constructor(note) {
    this.type = "notes";
    this.id = store.state.notes.length + 1;
    this.title = note?.title ?? "Note-" + store.state.notes.length + 1;
    this.content = note?.content ?? "Click here to start editing text";
    this.align = note.align ?? "left";
    this.fontSize = note.fontSize ?? "medium";
    this.border = note.border ?? "border";
  }
}

class PivotTable {
  constructor(pivot) {
    if (pivot == undefined) pivot = {};
    this.type = "pivotTables";
    this.id = store.state.pivotTables.length + 1;
    this.startOpen = true;
    this.source = pivot?.source ?? "table";
    this.dataType = pivot?.dataType ?? this.source;
    if (this.dataType == 'table') this.dataType = 'keyword';
    this.title = pivot?.title ?? "Pivot Table " + this.id;
    this.structure = pivot?.structure ?? this.source;

    //setting up tabulator columns
    this.groups = [];
    this.columns = [];

    if (this.source != "table") this.sourceID = pivot?.sourceID ?? 'table';

    if (pivot?.groups != undefined) {
      this.groups = pivot.groups.map(function (element) {
        return element.field;
      });
      pivot.groups.forEach(function (element, index) {
        this.columns.push({
          field: element.field,
          title: element.title,
          visible: true,
          formatter: "pivotGroupFormat",
        });
      }, this);
    }

    if (pivot?.columns != undefined && pivot?.calcArray != undefined) {
      pivot.columns.forEach(function (element, index) {
        this.columns.push({
          field: element.field + " " + index,
          title: pivot.calcArray[index] + " of " + element.title,
          visible: true,
          mutator: "customListMutator",
          mutatorParams: {
            type: pivot.calcArray[index],
            field: element.field,
            dataField: "rows",
          },
        });
      }, this);
    }

    if (pivot.data == undefined) pivot.data = table.getData();
    this.data = PivotGroupBy(pivot.data, this.groups);
  }
}

class Group {
  constructor(group) {
    this.id = group.id ?? store.state.groups.length;
    this.data = group.data;
    this.dataType = group.dataType ?? 'keyword';
    this.tableID = tableID++;
    this.title = group.title ?? group.data[0][this.dataType].substring(0, 20) + " group";
    this.rowAmount = group.data.length;
    this.statistics = group.statistics ?? [];
    this.type = "groups";
    this.formula = group.formula ?? "selected";
    this.expanded = group.expanded ?? false;
    this.loadingExpanded = group.loadingExpanded ?? false;
    this.customCol = group.customCol ?? [];
    this.columnManager = group.columnManager ?? [];
    this.updateCount = 0;
  }
}

class Project {
  constructor(project) {
    this.hash = project.hash ?? project.id;
    this.name = project.name;
    this.purchase_history = ReturnParsed(project.purchase_history) ?? [];
    this.purchaseTypes = { "keyword_data": false, "serp_results": false, "exact_serp_results": false };
    this.purchase_history.forEach(function (ele) {
      if (ele["exact-serp"]) this.purchaseTypes["exact_serp_results"] = true;
      if (ele["serp"]) this.purchaseTypes["serp_results"] = true;
      if (ele["sv_cpc"]) this.purchaseTypes["keyword_data"] = true;
    }, this);
    this.shared = project?.shared ?? false;
    this.sample = project?.sample ?? false;
    this.estimated_time = project?.estimated_time ?? '';
    this.purchaseDate = project?.purchaseDate ?? null;
  }
}

class Page {
  constructor(page) {
    this.title = page.title ?? "new tab";
    this.code = page.code ?? "unknown";
    this.items = page.items ?? [];
    this.active = false;
    this.name = "Page-" + store.state.pages.length;
    this.loaded = false;
    this.component = {
      props: ["props"],
      template: "<page-component v-bind:props='props'></page-component>",
    };
  }
}